"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InspectionClientMessageSchema = exports.InspectionServerMessageSchema = exports.IOrchestratorEventSchema = exports.OrchestratorEventTypeSchema = exports.OrchestratorEventType = exports.IOrchestratorSnapshotSchema = exports.IOrchestratorProfilingSnapshotSchema = exports.IActiveProfileSchema = exports.IProfileFilterSchema = exports.IProfileRequestSchema = exports.InspectionServerStateSchema = exports.InspectionServerState = exports.IProcessResourceStatsSchema = exports.IOrchestratorWorkerPoolStatsSchema = exports.IWorkerMetricsSnapshotSchema = exports.IWorkerMetricSampleSchema = exports.IOrchestratorQueueStatsSchema = exports.IAnalysisNodeSnapshotSchema = exports.INodeLockEntrySchema = exports.NodeLockStateSchema = exports.IAnalysisTimingDataSchema = exports.AnalysisNodeStatusSchema = exports.AnalysisNodeStatus = void 0;
const zod_1 = require("zod");
const AnalysisType_1 = require("./AnalysisType");
var AnalysisNodeStatus;
(function (AnalysisNodeStatus) {
    AnalysisNodeStatus["Adding"] = "Adding";
    AnalysisNodeStatus["Pending"] = "Pending";
    AnalysisNodeStatus["Running"] = "Running";
    AnalysisNodeStatus["Yielded"] = "Yielded";
    AnalysisNodeStatus["Awaiting"] = "Awaiting";
    AnalysisNodeStatus["Complete"] = "Complete";
    AnalysisNodeStatus["Failed"] = "Failed";
})(AnalysisNodeStatus || (exports.AnalysisNodeStatus = AnalysisNodeStatus = {}));
exports.AnalysisNodeStatusSchema = zod_1.z.nativeEnum(AnalysisNodeStatus);
exports.IAnalysisTimingDataSchema = zod_1.z.object({
    addedAt: zod_1.z.number(),
    startedAt: zod_1.z.number().optional(),
    endedAt: zod_1.z.number().optional(),
    activeRunTimeMs: zod_1.z.number().optional(),
    totalTimeMs: zod_1.z.number().optional(),
    totalCpuTimeMs: zod_1.z.number().optional(),
    peakHeapBytes: zod_1.z.number().optional(),
});
exports.NodeLockStateSchema = zod_1.z.enum(['requested', 'held', 'released']);
exports.INodeLockEntrySchema = zod_1.z.object({
    lockUid: zod_1.z.string(),
    resourceName: zod_1.z.string(),
    mode: zod_1.z.enum(['shared', 'exclusive']),
    state: exports.NodeLockStateSchema,
    requestedAt: zod_1.z.number(),
    acquiredAt: zod_1.z.number().optional(),
    releasedAt: zod_1.z.number().optional(),
});
exports.IAnalysisNodeSnapshotSchema = zod_1.z.object({
    id: zod_1.z.string(),
    type: AnalysisType_1.AnalysisTypeSchema,
    status: exports.AnalysisNodeStatusSchema,
    dependencies: zod_1.z.array(zod_1.z.string()),
    dependants: zod_1.z.array(zod_1.z.string()),
    timing: exports.IAnalysisTimingDataSchema,
    workerId: zod_1.z.number().optional(),
    workerName: zod_1.z.string().optional(),
    yieldCount: zod_1.z.number(),
    locks: zod_1.z.array(exports.INodeLockEntrySchema).optional(),
});
exports.IOrchestratorQueueStatsSchema = zod_1.z.object({
    concurrency: zod_1.z.number(),
    pending: zod_1.z.number(),
    running: zod_1.z.number(),
});
exports.IWorkerMetricSampleSchema = zod_1.z.object({
    timestamp: zod_1.z.number(),
    value: zod_1.z.number(),
});
exports.IWorkerMetricsSnapshotSchema = zod_1.z.object({
    workerId: zod_1.z.number(),
    workerName: zod_1.z.string().optional(),
    cpuPercent: zod_1.z.number(),
    heapUsedBytes: zod_1.z.number().optional(),
    rssBytes: zod_1.z.number().optional(),
    lastMemUpdateAt: zod_1.z.number().optional(),
    activeJobs: zod_1.z.number(),
    cpuHistory: zod_1.z.array(exports.IWorkerMetricSampleSchema),
    heapHistory: zod_1.z.array(exports.IWorkerMetricSampleSchema),
});
exports.IOrchestratorWorkerPoolStatsSchema = zod_1.z.object({
    size: zod_1.z.number(),
    activeJobs: zod_1.z.number(),
    workers: zod_1.z.array(exports.IWorkerMetricsSnapshotSchema).optional(),
});
exports.IProcessResourceStatsSchema = zod_1.z.object({
    pid: zod_1.z.number(),
    cpuPercent: zod_1.z.number(),
    rssBytes: zod_1.z.number(),
    heapUsedBytes: zod_1.z.number(),
    heapTotalBytes: zod_1.z.number(),
});
var InspectionServerState;
(function (InspectionServerState) {
    InspectionServerState["Initializing"] = "initializing";
    InspectionServerState["Processing"] = "processing";
    InspectionServerState["Idle"] = "idle";
})(InspectionServerState || (exports.InspectionServerState = InspectionServerState = {}));
exports.InspectionServerStateSchema = zod_1.z.nativeEnum(InspectionServerState);
exports.IProfileRequestSchema = zod_1.z.object({
    cpu: zod_1.z.boolean(),
    heapSampling: zod_1.z.boolean(),
    heapSnapshot: zod_1.z.boolean(),
});
exports.IProfileFilterSchema = zod_1.z.object({
    id: zod_1.z.string(),
    regexSource: zod_1.z.string(),
    regexFlags: zod_1.z.string(),
    types: exports.IProfileRequestSchema,
});
exports.IActiveProfileSchema = zod_1.z.object({
    nodeId: zod_1.z.string(),
    workerId: zod_1.z.number(),
    pumpIndex: zod_1.z.number(),
    types: exports.IProfileRequestSchema,
    startedAt: zod_1.z.number(),
});
exports.IOrchestratorProfilingSnapshotSchema = zod_1.z.object({
    filters: zod_1.z.array(exports.IProfileFilterSchema),
    activeProfiles: zod_1.z.array(exports.IActiveProfileSchema),
});
exports.IOrchestratorSnapshotSchema = zod_1.z.object({
    seq: zod_1.z.number(),
    timestamp: zod_1.z.number(),
    state: exports.InspectionServerStateSchema,
    nodes: zod_1.z.array(exports.IAnalysisNodeSnapshotSchema),
    queue: exports.IOrchestratorQueueStatsSchema,
    workerPool: exports.IOrchestratorWorkerPoolStatsSchema.optional(),
    resources: exports.IProcessResourceStatsSchema.optional(),
    profiling: exports.IOrchestratorProfilingSnapshotSchema.optional(),
});
var OrchestratorEventType;
(function (OrchestratorEventType) {
    OrchestratorEventType["NodeAdded"] = "node:added";
    OrchestratorEventType["NodeStatusChanged"] = "node:status_changed";
    OrchestratorEventType["NodeDependencyAdded"] = "node:dependency_added";
    OrchestratorEventType["NodeCompleted"] = "node:completed";
    OrchestratorEventType["NodeFailed"] = "node:failed";
    OrchestratorEventType["NodeYielded"] = "node:yielded";
    OrchestratorEventType["WorkerAssigned"] = "node:worker_assigned";
    OrchestratorEventType["LockRequested"] = "node:lock_requested";
    OrchestratorEventType["LockAcquired"] = "node:lock_acquired";
    OrchestratorEventType["LockReleased"] = "node:lock_released";
    OrchestratorEventType["ProfileStarted"] = "profile:started";
    OrchestratorEventType["ProfileCaptured"] = "profile:captured";
    OrchestratorEventType["ProfileWritten"] = "profile:written";
    OrchestratorEventType["ProfileWriteFailed"] = "profile:write_failed";
    OrchestratorEventType["ProfileSkipped"] = "profile:skipped";
    OrchestratorEventType["ProfileFilterAdded"] = "profile:filter_added";
    OrchestratorEventType["ProfileFilterRemoved"] = "profile:filter_removed";
    OrchestratorEventType["CapacityChanged"] = "pool:capacity_changed";
})(OrchestratorEventType || (exports.OrchestratorEventType = OrchestratorEventType = {}));
exports.OrchestratorEventTypeSchema = zod_1.z.nativeEnum(OrchestratorEventType);
exports.IOrchestratorEventSchema = zod_1.z.object({
    type: exports.OrchestratorEventTypeSchema,
    seq: zod_1.z.number(),
    timestamp: zod_1.z.number(),
    nodeId: zod_1.z.string(),
    data: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()),
});
exports.InspectionServerMessageSchema = zod_1.z.discriminatedUnion('type', [
    zod_1.z.object({ type: zod_1.z.literal('snapshot'), data: exports.IOrchestratorSnapshotSchema }),
    zod_1.z.object({ type: zod_1.z.literal('event'), data: exports.IOrchestratorEventSchema }),
    zod_1.z.object({ type: zod_1.z.literal('query_result'), requestId: zod_1.z.string(), data: zod_1.z.unknown().optional() }),
]);
exports.InspectionClientMessageSchema = zod_1.z.discriminatedUnion('type', [
    zod_1.z.object({ type: zod_1.z.literal('request_snapshot') }),
    zod_1.z.object({ type: zod_1.z.literal('query_node'), requestId: zod_1.z.string(), nodeId: zod_1.z.string() }),
    zod_1.z.object({
        type: zod_1.z.literal('query_completed'),
        requestId: zod_1.z.string(),
        sortBy: zod_1.z.enum(['duration', 'endedAt']).optional(),
        limit: zod_1.z.number().optional(),
    }),
    zod_1.z.object({ type: zod_1.z.literal('query_waiting_on'), requestId: zod_1.z.string(), nodeId: zod_1.z.string() }),
    zod_1.z.object({
        type: zod_1.z.literal('add_profile_filter'),
        requestId: zod_1.z.string(),
        regexSource: zod_1.z.string(),
        regexFlags: zod_1.z.string().optional(),
        types: exports.IProfileRequestSchema,
    }),
    zod_1.z.object({ type: zod_1.z.literal('remove_profile_filter'), requestId: zod_1.z.string(), filterId: zod_1.z.string() }),
    zod_1.z.object({ type: zod_1.z.literal('list_profile_filters'), requestId: zod_1.z.string() }),
]);
//# sourceMappingURL=OrchestratorInspection.js.map